var map = {
	"./banner1.jpg": "b87b",
	"./banner2.jpg": "6b5c",
	"./banner2关于我们.jpg": "30a5",
	"./banner3.jpg": "d6ed",
	"./banner3优秀成果.jpg": "de7d",
	"./banner4.jpg": "e6c8",
	"./banner4行业动态.jpg": "4c50",
	"./banner5.jpg": "2386",
	"./banner_500k.jpg": "def7",
	"./newyear.jpg": "f674",
	"./人才建设.jpg": "f338",
	"./会员天地.jpg": "e9c6",
	"./党建.jpg": "2430",
	"./党建1.jpg": "a43c",
	"./政策法规.jpg": "ce67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e4e9";